import SectionHeading from "./SectionHeading";
import { characters } from "@/mocks/movieContent";

const charImages = [
  "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20young%20man%20standing%20by%20a%20window%20with%20warm%20backlight%2C%20soft%20rim%20light%2C%20contemplative%20quiet%20mood%2C%20cinematic%20warm%20color%20grading%2C%20soft%20film%20grain%2C%20editorial%20portrait%20photography%2C%20elegant%20and%20atmospheric&width=500&height=600&seq=hap-char-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20young%20woman%20in%20a%20cozy%20warm%20lit%20room%2C%20soft%20golden%20lamp%20light%2C%20quiet%20thoughtful%20mood%2C%20cinematic%20warm%20color%20grading%2C%20soft%20film%20grain%2C%20editorial%20portrait%20photography%2C%20elegant%20and%20atmospheric&width=500&height=600&seq=hap-char-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20woman%20standing%20in%20a%20dim%20warm%20hallway%20of%20a%20home%2C%20warm%20side%20light%2C%20moody%20cinematic%20atmosphere%2C%20soft%20film%20grain%2C%20editorial%20portrait%20photography%2C%20warm%20amber%20palette%2C%20elegant%20and%20atmospheric&width=500&height=600&seq=hap-char-03&orientation=portrait",
  "https://readdy.ai/api/search-image?query=two%20distant%20silhouettes%20standing%20apart%20in%20a%20warmly%20lit%20room%2C%20quiet%20tension%20and%20emotional%20distance%2C%20cinematic%20warm%20color%20grading%2C%20soft%20film%20grain%2C%20editorial%20photography%2C%20elegant%20and%20atmospheric&width=500&height=600&seq=hap-char-04&orientation=portrait",
];

export default function CharacterSection() {
  return (
    <section id="characters" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="人物关系"
          title="人物与关系：谁在推动这段故事"
          description="影片的张力主要来自人物之间的位置变化。理清这一层关系，很多情绪细节就说得通了。"
          icon="ri-group-line"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {characters.map((person, index) => (
            <article
              key={person.name}
              className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300"
            >
              <div className="w-full h-52 md:h-60 overflow-hidden">
                <img
                  src={charImages[index]}
                  alt={`${person.name}的人物氛围示意`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{person.name}</h3>
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label whitespace-nowrap">
                    {person.role}
                  </span>
                </div>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{person.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-xs md:text-sm text-foreground-500 leading-relaxed">
          说明：以上角色以影片中的人物关系和叙事功能进行说明，用于帮助理解剧情结构，不涉及演员个人信息的佐证。
        </p>
      </div>
    </section>
  );
}